import { unparsedTokenCommand, apiTokenCommand, apiCommand } from "./index.jsx"
import { formatDateToShortDate } from "../utils"
import _ from "lodash"

const preparePayment = payment => _.pick( {
  ...payment,
  paymentDate: formatDateToShortDate( payment.paymentDate ),
  value: parseFloat( payment.value ),
}, [
  "id",
  "idPaymentAgreement",
  "value",
  "paymentDate",
  "paymentMethod",
  "isLastPayment",
])

export const addPayment = ( token: string, payment: any ) => apiTokenCommand( token, {
  command: "addPayment",
  args: preparePayment(payment),
} )

export const updatePayment = ( token: string, payment: any ) => apiTokenCommand( token, {
  command: "updatePayment",
  args: preparePayment(payment),
} )

export const removePayment = ( token: string, id: number ) => apiTokenCommand( token, {
  command: "removePayment",
  args: { id },
} )

export const deletePaymentDocument = ( token: string, id: number ) => apiTokenCommand( token, {
  command: "removeDocumentFromPayment",
  args: { id },
} )

export const getPaymentDocument = ( token: string, id: number, documentId: number ) => unparsedTokenCommand( token, {
  command: "getDocumentFromPayment",
  args: {
    id,
    documentId,
  },
} )

export const addPaymentDocument = async ( token: string, id: number, _document: File ) => {
  return await apiTokenCommand( token, {
    command: "addDocumentToPayment",
    args: { id },
  }, {
    files: _document,
  } )
}



// WEBPACK FOOTER //
// ./src/actions/payments.jsx